import { useContext, useState } from 'react'
import * as SETTINGS from '../../../../constants/settings'
import { SiteConfigContext } from '../../../../context/siteConfigContext'
import { toastSuccess } from '../../../../utils/toast'
import IconPicker from '../../../Utilities/IconPicker'
import Tooltip from '../../../Utilities/Tooltip'

const HubButton = () => {
  const { [SETTINGS.HUB_BUTTON.key]: hubButton, updateSetting } =
    useContext(SiteConfigContext)
  const [icon, setIcon] = useState(hubButton.icon)

  const handleSubmit = async (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    const data = {
      text: formData.get('text'),
      link: formData.get('link'),
      icon
    }
    await updateSetting(SETTINGS.HUB_BUTTON, data)
    toastSuccess('Hub Button saved.')
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center">
        <h2 className="mr-3">Hub Button</h2>
        <Tooltip>
          Configure your Hub Button by setting its text, link, and icon. This
          button directs users to your main hub page.
        </Tooltip>
      </div>

      <form
        onSubmit={(e) => handleSubmit(e)}
        autoComplete="off"
        className="grid grid-cols-1 md:grid-cols-2 gap-2"
      >
        <input
          aria-label="Hub Button Text"
          id="text"
          name="text"
          defaultValue={hubButton.text}
          className="input block w-full"
          placeholder="Text"
          required
        />
        <input
          aria-label="Hub Button Link"
          id="link"
          name="link"
          defaultValue={hubButton.link}
          className="input block w-full"
          placeholder="Link"
          required
        />
        <div className="md:col-span-2 flex gap-2">
          <IconPicker
            value={icon}
            title="Hub Button Icon"
            renderSelected
            collapsed
            onChange={(icon) => setIcon(icon)}
          />
          <button
            type="submit"
            aria-label="Save Hub Button Button"
            className="button-confirm w-fit"
          >
            Save
          </button>
        </div>
      </form>
    </div>
  )
}

export default HubButton
